module.exports = __webpack_public_path__ + "static/media/4-comp-camera.a2c57b58.jpg";